import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-scroll";

const PHONE = "(314) 665-0983";
const PHONE_HREF = "tel:+13146650983";
const EMAIL = "info@sagarluxuryride.com";
const EMAIL_HREF = "mailto:info@sagarluxuryride.com";

export default function Contact() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section
      id="contact"
      className="py-28 md:py-36 relative overflow-hidden"
      style={{ background: "#0a0a0a" }}
    >
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, #c9a84c 30%, #e2c87a 50%, #c9a84c 70%, transparent 100%)",
        }}
      />

      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at top, rgba(201,168,76,0.08) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8 text-center">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 28 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-gold tracking-[0.35em] text-xs uppercase mb-5 font-medium">
            Let's Get You There
          </p>

          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl text-cream font-semibold leading-tight mb-6">
            Ready to Ride?
          </h2>

          <div
            className="h-px mx-auto mb-8"
            style={{
              width: "60px",
              background: "linear-gradient(90deg, transparent, #c9a84c, transparent)",
            }}
          />

          <p className="text-cream/55 text-base md:text-lg leading-relaxed mb-12 max-w-lg mx-auto">
            Book online, call us directly, or send an email. Available 24/7.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
            <a
              href={PHONE_HREF}
              className="group flex items-center gap-3 text-cream hover:text-gold transition-colors duration-300"
            >
              <div
                className="w-10 h-10 border border-gold/30 group-hover:border-gold/60 flex items-center justify-center text-gold transition-colors duration-300"
                style={{ background: "rgba(201,168,76,0.06)" }}
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
              </div>
              <span className="font-medium tracking-wide">{PHONE}</span>
            </a>

            <div className="hidden sm:block w-px h-8 bg-white/10" />

            <a
              href={EMAIL_HREF}
              className="group flex items-center gap-3 text-cream hover:text-gold transition-colors duration-300"
            >
              <div
                className="w-10 h-10 border border-gold/30 group-hover:border-gold/60 flex items-center justify-center text-gold transition-colors duration-300"
                style={{ background: "rgba(201,168,76,0.06)" }}
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
              <span className="font-medium tracking-wide">{EMAIL}</span>
            </a>
          </div>

          <p className="text-cream/30 text-xs mb-10">
            7777 Bonhomme Avenue, Suite 1800, Clayton, MO 63105
          </p>

          <Link to="booking" smooth duration={700} offset={-112}>
            <button className="btn-gold text-base px-10 py-4">
              Book Now
            </button>
          </Link>
        </motion.div>
      </div>

      <div
        className="absolute bottom-0 left-0 right-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, #c9a84c 30%, #e2c87a 50%, #c9a84c 70%, transparent 100%)",
        }}
      />
    </section>
  );
}
